module.exports = __webpack_public_path__ + "img/slide_8.d28fa501.webp";